import { JobReview } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore, subscribeOnJobReviewAdded } from '@dinosband/bv-main-client'

import { BvSubscriber } from './manager/subscriber'

interface _ContextType {
  mainStore: MainStore
}

export class JobReviewSubscriber extends BvSubscriber<JobReview> {
  context: _ContextType

  constructor (context: _ContextType, callback: (value: JobReview) => void) {
    super(callback as unknown as (value: JobReview | JobReview[]) => void)
    this.context = context
  }

  protected async query () {
    return undefined
  }

  protected async subscribe () {
    const mainStore = this.context.mainStore
    if (!mainStore?.userId || mainStore.userId <= 0) {
      return
    }
    return subscribeOnJobReviewAdded(await mainStore.apollo.getClient(), [], mainStore.userId, (value) => { this.callback(value) })
  }

}
